<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"><router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Vehicle Sales  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/svehiclesalesorder/index">Manage Vehicle Sales Order  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.so_code }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                  <button   @click="acceptPuchase()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Accept Purchase Order</button>
                  <button v-if="all_data.status==3"  @click="Createso()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad">  Create SO</button>
                  
                  <button v-if="all_data.status==1"  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="all_data.status==1"  @click="Confimmodel()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                  <button   @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                
                  <!-- v-if="all_data.status!=1" -->
            
                </div>
                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

              <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                  <div >



                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">

                  <div class="table-responsive">
                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>SO Code </b></td>
                           <td>{{ all_data.so_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>PFI Number</b></td>
                            <td>{{ all_data.relatedToPfi.pfi_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Customer</b></td>
                           <td>{{ all_data.relatedToCustomer.user_full_name }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Dealer</b></td>
                           <td>{{ all_data.relatedToDealer.C_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sales Rep. </b></td>
                           <td>{{ all_data.relatedToSalesperson.name }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Model Name</b></td>
                           <td>{{ all_data.modelname }}</td> 
                          </tr>
                          <tr>
                            <td><b>Color</b></td>
                           <td>{{ all_data.color }} </td> 
                          </tr>
                          <tr>
                            <td><b>Engine </b></td>
                           <td>{{ all_data.engine }}</td> 
                          </tr>
                          <tr>
                            <td><b>Chassis </b></td>
                           <td>{{ all_data.chassis }}</td> 
                          </tr>
                          <tr>
                            <td><b>Issued Accessories </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Received Date</b></td>
                           <td>{{ all_data.received_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Selling Price</b></td>
                           <td>{{ all_data.selling_price }}</td> 
                          </tr>
                          <tr>
                            <td><b>Discount Amount</b></td>
                           <td>{{ all_data.discount_amount }}</td> 
                          </tr>
                          <tr>
                            <td><b>Sub Total</b></td>
                           <td>{{ all_data.sub_total }}</td> 
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ all_data.relatedToStatus.status }}</td> 
                          </tr>
                          
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ all_data.created_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Username</b></td>
                           <td>{{ all_data.relatedToUser.username }}</td> 
                          </tr>
                          <tr>
                            <td><b>Last Status Change Date</b></td>
                           <td>{{ all_data.last_status_changed_date }}</td> 
                          </tr>

                        
                        <!-- <span v-show="all_data.po_number!=''"> -->
                          <tr v-show="all_data.po_number!=''">
                            <td><b>PO Number</b></td>
                           <td>{{ all_data.po_number }}</td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td ><b>Upload PO Copy</b></td>
                           <td></td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td><b>PO Value</b></td>
                           <td>{{ all_data.po_value }}</td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td><b>Leasing Company</b></td>
                           <td>{{ leasing }}</td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td><b>PO Accept Remarks</b></td>
                           <td>{{ all_data.po_remaks }}</td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td ><b>Upload Date</b></td>
                           <td>{{ all_data.upload_date }}</td> 
                          </tr>
                          <tr v-show="all_data.po_number!=''">
                            <td><b>Upload By</b></td>
                           <td>{{ uploadname }}</td> 
                          </tr>
                      
                          
                         
                           
                        </tbody>
                 
                 
                      </table>

                      </div>
                      </div>
                      </div>



                      <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Transactions Related To Sales Order</b></h6>

                        <div class="table-responsive">                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead class="background_color2">
                            <tr class="custom-label2">
                              <th>#</th>
                              <th>Transaction</th>
                              <th >Transaction Date</th>
                              <th >Amount (Rs)</th>
                              <th >Paid Amount (Rs)</th>
                              <th >Balance (Rs)</th>
                          
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(datatran, index) in datatrans" :key="datatran.id">
                              <td>{{ index+1 }}</td>
                              <td>{{datatran.transaction_no}} </td>
                              <td >{{datatran.transaction_date}}</td>
                              <td >{{datatran.trans_amount}}</td>
                              <td >{{datatran.pay_amount}}</td>
                              <td >{{datatran.balance}}</td>
                            
                              </tr>
                              
                            </tbody>

                          </table>
                          </div>

                        </div>
                    </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Advance Payments</b></h6>


<div class="row">


<div class="col-md-3">
<div class="form-group required">
  <label class="custom-label" style="font-size: small;">Payment Mode</label>
            <v-select class="font-size_def" label="label"  @input="selectmode"  v-model="payment.payment_mode"  :options="paymentmethods" ></v-select>
           
       
</div>
</div>
<div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Receipt Date</label>
        <input  v-model="payment.receipt_date" type="date" style="font-size: small;" class="form-control" required>
       
</div>
</div>


</div>



<div class="row">



  <div class="col-md-3">
<div class="form-group required">
        <label class="custom-label" style="font-size: small;">Paid Amount</label>
        <input  v-model="payment.paid_amount"  style="font-size: small;" class="form-control" required>
       
</div>
</div>


<div class="col-md-3">
<div class="form-group required">
  <label class="custom-label" style="font-size: small;">Bank</label>
            <v-select class="font-size_def" label="bank_name"  v-model="payment.bank"  :options="banks" ></v-select>
           
       
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
        <label class="custom-label" style="font-size: small;">Bank Slip Image</label>
        <input   type="file" style="font-size: small;" class="form-control" >
       
</div>
</div>



</div>

<div class="row" v-if="chequ">



<div class="col-md-3">
<div class="form-group required">
      <label class="custom-label" style="font-size: small;">Cheque Date</label>
      <input  v-model="payment.cheque_date" type="date"  style="font-size: small;" class="form-control" required>
     
</div>
</div>


<div class="col-md-3">
<div class="form-group required">
<label class="custom-label" style="font-size: small;">Cheque No.</label>
<input   v-model="payment.cheque_no"  style="font-size: small;" class="form-control" >
         
     
</div>
</div>
<div class="col-md-3">
<div class="form-group ">
      <label class="custom-label" style="font-size: small;">Realised Amount</label>
      <input  v-model="payment.realised_amount"   style="font-size: small;" class="form-control" >
     
</div>
</div>

<div class="col-md-3">
<div class="form-group required">
      <label class="custom-label" style="font-size: small;">Realised Date</label>
      <input type="date"  v-model="payment.realised_date"  style="font-size: small;" class="form-control" required>
     
</div>
</div>

</div>



                          <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead class="background_color2">
                            <tr class="custom-label2">
                              <th>#</th>
                              <th>Receipt Number</th>
                              <th >Receipt Date</th>
                              <th >Bank Slip</th>
                              <th >Paid Amount Rs.</th>
                              <th >Payment Mode</th>
                              <th >Payment Type</th>
                              <th >Realised Amount Rs.</th>
                              <th >Actions</th>
                          
                              </tr>
                            </thead>
                            <tbody>
                              <!-- v-for="(datatran, index) in datatrans" :key="datatran.id" -->
                              <tr v-for="(receipt, index) in receipts" :key="receipt.id">
                              <td>{{ index + 1 }}</td>
                              <td>{{ receipt.receipt_code }}</td>
                              <td >{{ receipt.receipt_date }}</td>
                              <td ></td>
                              <td >{{ receipt.paid_amount }}</td>
                              <td >{{ receipt.payment_mode }}</td>
                              <td >{{ receipt.payment_type }}</td>
                              <td >{{ receipt.realised_amount }}</td>
                              <td >  <button  @click="confirmreceipt()"  class="mr-1 btn btn-outline-primary btn-sm mb-1 font-size_def bdr-rad">Confirm</button>
                                </td>
                            
                              </tr>
                              
                            </tbody>

                          </table>
                          </div>

 <div style="border-bottom: 0px; padding-top: 0px; " class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
        <button  @click="addCreate()"  class="mr-1 btn btn-outline-primary  mb-1 font-size_def bdr-rad">Add</button>
    </div>
    </div>


                        </div>
                    </div>








                 



                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                 <div class="table-responsive"> 
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                <thead class="background_color2">
                  <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }}</td>
                    <td>{{ mservicelog.relatedToUser.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.relatedToFollowupby.username }}</td>
                  
                    
                    </tr>
                  </tbody>

                </table>
                </div>

            

       

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add CRM Note</button>
                </div>
                </div>

            </div>
        </div>


        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                        <div class="table-responsive">
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                          <thead class="background_color2">
                            <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>
                          </div>

                        </div>
                    </div>




   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
    import vSelect from 'vue-select';
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
           
            all_data:{},
            payment:{},
            total:{},
           
           
            status:{},
            leasing:{},
            user:{},
            uploadname:{},
            banks:[],
            crm:{},
            details:[],
            datatrans:[],
            mservicelogs:[],
            receipts:[],
            trans:[],
            width:5,
            height:5,
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        chequ:false,

        paymentmethods: [
            { label: 'Cash', value: 'Cash' },
            { label: 'Cheque', value: 'Cheque' },
            // Add more options as needed
        ],

        // imageUrl: '/img/evenware-logo.png' 
           
          }
    
        },
        components :{
          'v-select': vSelect,
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
    async selectmode(){
      if(this.payment.payment_mode['value']=="Cheque"){
           
         
           this.chequ = true;
         }else if(this.payment.payment_mode['value']=="Cash"){
          this.chequ = false;
         }


      },



    async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },



          async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/spfi/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },


     async addCreate() {
       
    
       try {
         const { data} = await  axios.post('/svehiclesalesorder/addcreate?id='+this.id,{payment:this.payment,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/svehiclesalesorder/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },



    

     async loadSquatation() {
  
      try {
        const { data} = await  axios.get('/svehiclesalesorder/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_data = data.all_data
         this.datatrans = data.datatrans
          this.uploadname = data.uploadname
          this.mservicelogs = data.mservicelogs
          this.banks = data.banks
          this.receipts = data.receipts
          this.leasing = data.leasing
        //  this.total = data.total
       
       
        
      } catch (error) {
        console.log(error.response);
      }
    },


    async Update(){
        this.$router.push('/svehiclesalesorder/update?id='+this.id);
      },
    async acceptPuchase(){
        this.$router.push('/svehiclesalesorder/acceptpo?id='+this.id);
      },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>